import { Injectable } from '@angular/core';
import { CompoundFilter } from '@itonics/filters';
import { SearchField } from '../interfaces/feed';

/**
 * Handles the redirection when the user wants to refine a signals feed
 * This way, the host app can override the default behaviour (eg. in the
 * insights app, we can open the feed in the app instead of opening
 * a new tab for it)
 */
export abstract class FeedRedirectionService {
  public abstract redirectToInsights(params: { url: string; searchField?: SearchField; filter?: CompoundFilter });
}

/**
 * Default feed redirection service (will be used if the host app doesn't provide any override)
 */
@Injectable()
export class FeedRedirectionDefaultService implements FeedRedirectionService {
  /**
   * Default behaviour: open the given url in a new tab
   * Ignore any passed filter/searchField params
   *
   * @param url Target url
   */
  public redirectToInsights({ url }: { url: string }) {
    window.open(url, '_blank');
  }
}
